const getCountryRegion = (locale: string) => {
    // https://ecoflow.feishu.cn/wiki/A6kNw0lhiivAIdkpiZBcblBxnEh
    const EU_MAP = [
        // Europe
        'eu',
        'uk',
        'de',
        'fr',
        'it',
        'es',
        'nl',
        // Asia
        'jp',
        'kr',
        'za',
        'sa',
    ];
    const CN_MAP = ['cn'];
    if (CN_MAP.includes(locale)) return 'cn';
    if (EU_MAP.includes(locale)) return 'eu';
    return 'us';
};

const API_HOST_US = typeof window === 'undefined' ? process.env.RSC_API_HOST : process.env.NEXT_PUBLIC_API_HOST || 'https://api-a.ecoflow.com/website';
const API_HOST_CN = typeof window === 'undefined' ? process.env.RSC_API_HOST_CN : process.env.NEXT_PUBLIC_API_HOST_CN || 'https://api-cn.ecoflow.com/website';
const API_HOST_EU = typeof window === 'undefined' ? process.env.RSC_API_HOST_EU : process.env.NEXT_PUBLIC_API_HOST_EU || 'https://api-e.ecoflow.com/website';

const LOGIN_HOST_US = typeof window === 'undefined' ? process.env.RSC_LOGIN_HOST : process.env.NEXT_PUBLIC_LOGIN_HOST || 'https://api-a.ecoflow.com';
const LOGIN_HOST_CN = typeof window === 'undefined' ? process.env.RSC_LOGIN_HOST_CN : process.env.NEXT_PUBLIC_LOGIN_HOST_CN || 'https://api-cn.ecoflow.com';
const LOGIN_HOST_EU = typeof window === 'undefined' ? process.env.RSC_LOGIN_HOST_EU : process.env.NEXT_PUBLIC_LOGIN_HOST_EU || 'https://api-e.ecoflow.com';

export default function getHostApiOnline(locale = 'us') {
    const obj = {
        NEXT_PUBLIC_API_HOST: API_HOST_US,
        NEXT_PUBLIC_LOGIN_HOST: LOGIN_HOST_US,
    };

    if (getCountryRegion(locale) === 'cn') {
        obj.NEXT_PUBLIC_API_HOST = API_HOST_CN;
        obj.NEXT_PUBLIC_LOGIN_HOST = LOGIN_HOST_CN;
    }

    if (getCountryRegion(locale) === 'eu') {
        obj.NEXT_PUBLIC_API_HOST = API_HOST_EU;
        obj.NEXT_PUBLIC_LOGIN_HOST = LOGIN_HOST_EU;
    }

    return obj;
}
